import { useEffect } from 'react'

import { useStore } from 'store/useStore'

import { AddingEmployeeType } from '../data'
import { setRolesOnSomePvz } from './setRolesOnSomePvz'

export const useChangeUserRole = (addingEmployeeValue: AddingEmployeeType) => {
  const { viewEmployeeUiStore: uiStore } = useStore()

  const selectedPvzId = uiStore.selectedPvz?.id

  useEffect(() => {
    switch (addingEmployeeValue) {
      case AddingEmployeeType.only: {
        uiStore.employeeRoleList.forEach((roleItem) => {
          if (roleItem.id === selectedPvzId) {
            roleItem.setRole(uiStore.selectedRole)
          } else {
            roleItem.setRole(roleItem.cachedRole)
          }
        })

        if (selectedPvzId) {
          uiStore.setELockRoleList([
            {
              elock_permission: uiStore.selectedELockRole,
              user_id: uiStore.selectedUserId,
              pickpoint_id: selectedPvzId,
            },
          ])
        }

        break
      }

      case AddingEmployeeType.all: {
        uiStore.setELockRoleList([])

        uiStore.employeeRoleList.forEach((roleItem) => {
          if (roleItem.id) {
            roleItem.setRole(uiStore.selectedRole)

            uiStore.setELockRoleList([
              ...uiStore.eLockRoleList,
              {
                user_id: uiStore.selectedUserId,
                pickpoint_id: roleItem.id,
                elock_permission: uiStore.selectedELockRole,
              },
            ])
          }
        })

        break
      }

      case AddingEmployeeType.some: {
        setRolesOnSomePvz(uiStore)
        break
      }
    }
  }, [
    uiStore,
    addingEmployeeValue,
    selectedPvzId,
    uiStore.selectedRole,
    uiStore.employeeRoleList,
    uiStore.employeeELockRoleList,
    uiStore.selectedELockRole,
  ])
}
